import {
  RootFactory,
  ServicesFactory,
  TestimonialsFactory,
  ContactFactory,
  PortfolioFactory,
  PortfolioFiltersFactory,
} from '../factories';

export const butterflyBuilder = () => {
  return {
    buildTemplate: (website) => ({
      theme: "butterfly",
      ...RootFactory.getButterfly(website),
      services: ServicesFactory.getButterfly(website),
      testimonials: TestimonialsFactory.getButterfly(website),
      contact: ContactFactory.getButterfly(website),
      portfolio: PortfolioFactory.getBase(website),
      portfolioFilters: PortfolioFiltersFactory.getBase(website),
    })
  };
};



// WEBPACK FOOTER //
// ./src/store/generators/websiteTemplates/builders/ButterflyBuilder.js